import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timer'
})
export class TimerPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value) {
      const hours = `00${Math.floor(+value/3600)}`
      const minute = `00${Math.floor(+value/60)}`
      const second = `00${+value - Math.floor(+value/3600) * 3600 - Math.floor(+value/60) * 60}`

      return `${hours.slice(-2)}:${minute.slice(-2)}:${second.slice(-2)}`;
    } else {
      return null;
    }
  }

}
